import React, { useCallback, useState, useEffect, useContext } from "react";
import { process } from "@progress/kendo-data-query";
import {
  Grid,
  GridColumn,
  GridToolbar,
  GridPageChangeEvent,
} from "@progress/kendo-react-grid";
import {
  setGroupIds,
  getGroupIds,
  setExpandedState,
} from "@progress/kendo-react-data-tools";
import { UiSingleSwitch } from "../../../../_uiComponents/telerikComponents/UiSwitch";
import {
  ApprovedIcon,
  NotApprovedIcon,
} from "../../../../_uiComponents/common/DataGridComponents";
import SendActivationEmail from "../forms/SendActivationEmail";
import TransferDealer from "../forms/TransferDealer";
import TransferJobRole from "../forms/TransferJobRole";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { DropDownButton } from "@progress/kendo-react-buttons";
import { gearIcon } from "@progress/kendo-svg-icons";
import UiSelect from "../../../../_uiComponents/common/form/UiSelectDefault";
import { useDispatch, useSelector } from "react-redux";
import { Button } from '@progress/kendo-react-buttons';
import { Input } from '@progress/kendo-react-inputs';
import { filterBy } from '@progress/kendo-data-query';
import {
  participantDeleteParticipantRequest,
  participantGetApplicationRequest,
  participantGetParticipantSummaryRequest,
  participantUpdateParticipantStatusRequest,
} from "../../../../../_redux/_actions";
import { contextApiActions } from "../../../../../_redux/_constants";
import { Context } from "../../../../../_context/Store";
import ViewParticipantDetails from "../forms/ViewParticipantDetails";
import moment from "moment/moment";
import UiInput from '../../../../_uiComponents/telerikComponents/UiInput'
import {
  UiButton,
} from "../../../../_uiComponents/common/form/UiButton";
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { UiCheckBox } from "../../../../_uiComponents/telerikComponents/UiCheckBox";

const initialDataState = {
  take: 10,
  skip: 0,
  group: [{ field: 'application' }, { field: "area" }, { field: "jobRole" }],
  currentPage:0,
};

const processWithGroups = (data, dataState) => {
  const newDataState = process(data, dataState);
  setGroupIds({ data: newDataState.data, group: dataState.group });
  return newDataState;
};


const ParticipantsManagementGrid = () => {
  const actionDispatch = useDispatch();
  const { applications, recodeList } = useSelector((state) => ({
    applications: state?.participantsManagement?.application,
    recodeList: state?.participantsManagement?.recodeList,
  }));

  const [products, setProducts] = useState([]);
  const [dataState, setDataState] = useState(initialDataState);
  const [resultState, setResultState] = useState(processWithGroups([], initialDataState));
  const [collapsedState, setCollapsedState] = useState([]);
  const [applicationType, setApplicationType] = useState(null);
  const [pageTake, setPageTake] = useState(initialDataState.take)

  // useEffect(() => {
  //   if (recodeList?.recordsList && recodeList.recordsList.length > 0) {
  //     setProducts(recodeList.recordsList);
  //   }
  // }, [recodeList]);



  useEffect(() => {
    actionDispatch(participantGetApplicationRequest());
  }, [actionDispatch]);

  useEffect(() => {
    actionDispatch(
      participantGetParticipantSummaryRequest({
        applicationId: applicationType ? applicationType : 0,
        page: dataState?.currentPage,
        pageSize: dataState?.take,
      })
    );
  }, [actionDispatch, applicationType]);

  const onDataStateChange = useCallback((event) => {
    
    const newDataState = processWithGroups(products, event.dataState);

    const currentPage = event?.dataState?.skip / event?.dataState?.take + 1 

    console.log(event);

    setDataState(event.dataState);
    

    // actionDispatch(participantGetParticipantSummaryRequest({
    //   applicationId: applicationType ? applicationType : 0,
    //   page: dataState?.skip,
    //   pageSize: dataState?.take,
    // }));




    //setResultState(newDataState);
  }, []);


  const onExpandChange = useCallback(
    (event) => {
      console.log("Hit");
      const item = event.dataItem;

      if (item.groupId) {
        const newCollapsedIds = !event.value
          ? [...collapsedState, item.groupId]
          : collapsedState.filter((groupId) => groupId !== item.groupId);
        setCollapsedState(newCollapsedIds);
      }
    },
    [collapsedState]
  );
  const handleStatusToggle = (id, status) => {

    const updateActiveStatus = (items) => {
      if (!Array.isArray(items)) return items;

      return items.map((item) => {
        if (Array.isArray(item.items)) {
          return {
            ...item,
            items: updateActiveStatus(item.items),
          };
        }
        if (item.id === id) {
          return {
            ...item,
            active: !item.active,
          };
        }
        return item;
      });
    };

    actionDispatch(participantUpdateParticipantStatusRequest({
      ParticipantId: id,
      Active: status ? false : true,
      applicationId: applicationType ? applicationType : 0,
      page: dataState?.currentPage,
      pageSize: dataState?.take,
    }))

    const updatedState = updateActiveStatus(resultState.data);

    setResultState({
      data: updatedState,
    });
  };



  const StatusCell = (props) => {
    const { id, active } = props.dataItem;
    return (
      <td {...props.tdProps} >
        <UiSingleSwitch
          handleChange={() => handleStatusToggle(id, active)}
          checked={active}
        />
      </td>
    );
  };

  const SendActivationFunction = () => {

  }

  const ActionArea = (props) => {
    
    let settings = [
      { text: "Send Activation Email", id: 1 },
      { text: "Transfer Dealer", id: 2 },
      { text: "Transfer Job Role", id: 3 },
    ];

    if(props?.dataItem?.jobRole === "Area Manager"){
      settings = [
        { text: "Send Activation Email", id: 1 },
      ];
    }

    const [state, dispatch] = useContext(Context);

    const handleItemClick = (data, e) => {
      switch (e.item.id) {
        case 1:
          dispatch({
            type: contextApiActions.UI_MODAL_TOGGEL,
            payload: {
              show: true,
              heading: "Send Activation Email",
              children: <SendActivationEmail data={data}  />,
            },
          });
          break;
        case 2:
            dispatch({
              type: contextApiActions.UI_MODAL_TOGGEL,
              payload: {
                show: true,
                heading: "Transfer Dealer",
                children: <TransferDealer currentDealer={data} />,
              },
            });
          break;
        case 3:
          dispatch({
            type: contextApiActions.UI_MODAL_TOGGEL,
            payload: {
              show: true,
              heading: "Transfer Job Role",
              children: <TransferJobRole currentJobRole={data} />,
            },
          });
          break;
        default:
          break;
      }
    };

    const handleViewData = (data) => {
      dispatch({
        type: contextApiActions.UI_MODAL_TOGGEL,
        payload: {
          show: true,
          heading: "Participant Details",
          children: <ViewParticipantDetails participantDetails={data} />,
        },
      });
    }

    const handleDelete = (id) => {
      dispatch({
        type: contextApiActions.UI_CONFIRMATION_TOGGEL,
        payload: {
          show: true,
          okFunction: () => {
            actionDispatch(participantDeleteParticipantRequest({
              participantId: id,
              applicationId: applicationType ? applicationType : 0,
              page: dataState?.currentPage,
              pageSize: dataState?.take,
            }))
            console.log(id)
          }
        },
      });
    };

    return (
      <td {...props.tdProps} colSpan={4}>
        <div className="sbt-data-grid__action-bar">
          <Tooltip title="View" placement="top" arrow>
            <IconButton onClick={() => handleViewData(props.dataItem)}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          {/* <Tooltip title="Edit" placement="top" arrow>
            <IconButton onClick={() => console.log("Edit", props.dataItem)}>
              <EditIcon />
            </IconButton>
          </Tooltip> */}
          <Tooltip title="Delete" placement="top" arrow>
            <IconButton
              onClick={() => handleDelete(props.dataItem.id)}
            >
              <DeleteIcon color="error" />
            </IconButton>
          </Tooltip>
          <DropDownButton
            className="sba-grid-action-btn"
            themeColor={"primary"}
            items={settings}
            svgIcon={gearIcon}
            text="Actions"
            onItemClick={(e) => handleItemClick(props.dataItem, e)}
          />
        </div>
      </td>
    );
  };


  const AtivatedStatusCell = (props) => (
    <td {...props.tdProps} style={{ textAlign: "center", paddingLeft: '0px', paddingRight: '0px' }}>
      <div className="sba-activated-wr">
        {props.dataItem.accountActivated ? <ApprovedIcon /> : <NotApprovedIcon />}
        {props.dataItem.accountActivatedOn && (
          <span> {moment(props.dataItem.accountActivatedOn).format('YYYY-MM-DD')}</span>
        )}
      </div>
    </td>
  );

  const onGroupsToggle = React.useCallback(() => {
    const dataStateWithoutPaging = processWithGroups(products, {
      group: dataState.group
    });
    setCollapsedState(collapsedState.length ? [] : getGroupIds({
      data: dataStateWithoutPaging.data
    }));
  }, [collapsedState, dataState]);


  const filterData = e => {
    let value = e.target.value;
    let filter = {
      logic: 'or',
      filters: [{
        field: 'jobRole',
        operator: 'contains',
        value: value
      }, {
        field: 'email',
        operator: 'contains',
        value: value
      }
      ]
    };

    console.log('value', value);
    console.log(resultState.data);
    
    
    if (value !== "") {
      setProducts(filterBy(resultState.data, filter));
    } else {
      actionDispatch(
        participantGetParticipantSummaryRequest({
          applicationId: applicationType ? applicationType : 0,
          page: dataState?.currentPage,
          pageSize: dataState?.take,
        })
      );
    }
  };

  const onGroupChange = useCallback((event) => {
    const newGroups = event.group;

    const newDataState = processWithGroups(products, { ...dataState, group: newGroups });

    setDataState((prevState) => ({
      ...prevState,
      group: newGroups,
    }));

    setResultState(newDataState);
  }, [products, dataState]);

  const handlePageChange = (event) => {
  
    const currentPage = event.page.skip / event.page.take + 1;
   
    // setDataState((prevState) => ({
    //   ...prevState,
    //   skip: event.page.skip,
    //   take: event.page.take,
    // }));

    setDataState((prevState) => ({
      ...prevState,
      take: event.page.take,
      skip:event.page.skip,
      currentPage:currentPage,
    }));

    actionDispatch(participantGetParticipantSummaryRequest({
      applicationId: applicationType ? applicationType : 0,
      page: currentPage,
      pageSize: dataState?.take,
    }));

    
  };


  useEffect(() => {
    if (recodeList.recordsList && recodeList.recordsList.length > 0) {
      const newDataState = processWithGroups(recodeList.recordsList,{ ...dataState, skip: 0});
      setResultState(newDataState);
      
    }
  }, [recodeList, dataState]);

  const searhValidator = value => value ? '' : 'Search field is required.';
  const handleSubmit = dataItem => {

    const data = {
      name: dataItem.search,
      fields: fieldChecked
    }

   const uniqueKeys = Array.from(new Set(data.fields));

    const payload = uniqueKeys
    .map((key) => `${(key)}=${data.name}`)
    .join("&");

    actionDispatch(participantGetParticipantSummaryRequest({
      applicationId: applicationType ? applicationType : 0,
      page: dataState?.currentPage,
      pageSize: dataState?.take,
      query:payload
    }));
  }


  const [fieldChecked, setFieldChecked] = useState([]);

  const handleCheckBoxChange = (e) => {
    if (e.target.value) {
      setFieldChecked([...fieldChecked, e.target.name]);
    } else {
      setFieldChecked(fieldChecked.filter((item) => item !== e.target.name));
    }
  }

  return (
    <div className="sba-telerik-components-wr">

      <Grid
        groupable={true}
        data={setExpandedState({
          data: resultState.data.length === 0 ? products : resultState.data,
          collapsedIds: collapsedState,
        })}
        group={dataState.group} // Pass the grouping configuration
        total={recodeList?.totalRecords || 0}
        skip={dataState.skip}
        pageSize={dataState.take}
        pageable={{        
          pageSizes: [5, 10],         
        }}
        onGroupChange={onGroupChange}
        onExpandChange={onExpandChange}
        //onDataStateChange={onDataStateChange}
        onPageChange={handlePageChange}
      >
        <GridToolbar>
          <div className="sba-participant-chart-section-top-search">
            {applications.length !== 0 && (
              <UiSelect
                label="Application"
                options={applications.map((app) => ({
                  value: app.id.toString(),
                  label: app.name,
                }))}
                value={applicationType}
                handleChange={setApplicationType}
              />
            )}
          </div>
          <div className="sb-grid-main-search">
            <Form onSubmit={handleSubmit}
              render={formRenderProps =>
                <>
                  <div className="sb-grid-main-search__top">
                  <div className="sb-grid-main-search__top-wr">
                    <div className="sb-grid-main-search__top-search">
                     <Field name={'search'}
                      component={UiInput}                     
                      labelClassName={'k-form-label'}
                      placeholder={'Search'} />
                    </div>
                    
                    <div className="sb-grid-main-search__bottom">    
                  <Field
                      name={'area'}
                      component={UiCheckBox}
                      handleChange={(e) => handleCheckBoxChange(e)}
                      value={'Area'}
                      label="Area"
                      labelClassName={'k-form-label'}
                    />
                     <Field
                      name={'dealerCode'}
                      component={UiCheckBox}
                      handleChange={(e) => handleCheckBoxChange(e)}
                      value={'DealerCode'}
                      label="Dealer Code "
                      labelClassName={'k-form-label'}
                    />
                     <Field
                      name={'dealerName'}
                      component={UiCheckBox}
                      handleChange={(e) => handleCheckBoxChange(e)}
                      value={'DealerName'}
                      label="Dealer Name"
                      labelClassName={'k-form-label'}
                    />

                    <Field
                      name={'jobRole'}
                      component={UiCheckBox}
                      handleChange={(e) => handleCheckBoxChange(e)}
                      value={'JobRole'}
                      label="Job Role"
                      labelClassName={'k-form-label'}
                    />
                    <Field
                      name={'email'}
                      component={UiCheckBox}
                      handleChange={(e) => handleCheckBoxChange(e)}
                      value={'Email'}
                      label="Email"
                      labelClassName={'k-form-label'}
                    />
                   
                   
                  </div>
                  </div>
                  <div className="sb-grid-main-search__top-search-btns">
                    <UiButton
                      name="Search"
                      variant="contained"
                      size="small"
                      onClick={formRenderProps.onSubmit}
                    />
                    <UiButton
                      name="Clear"
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        formRenderProps.onFormReset()
                        actionDispatch(participantGetParticipantSummaryRequest({
                          applicationId: applicationType ? applicationType : 0,
                          page: dataState?.currentPage,
                          pageSize: dataState?.take,
                        }));
                      }}
                    />
                </div>
                  </div>
                  
                </>
              } />
          </div>

         
        </GridToolbar>

        <GridToolbar>
          <div className="sb-grid-search-section">          
            <span>
              <Input onChange={filterData} placeholder="Filter"/>
            </span>
          </div>
        </GridToolbar>
        
        <GridColumn field="application" title="Application" width="100px" />
        <GridColumn field="area" title="Area" width="80px" />
        <GridColumn field="dealershipCode" title="Dealer Code" width="100px" />
        <GridColumn field="jobRole" title="Job Role" width="120px" />
        <GridColumn field="email" title="Email" width="230px" />
        <GridColumn
          title="Name"
          width="200px"
          cell={(props) => {
            const { firstName, lastName } = props.dataItem;
            return (
              <td {...props.tdProps} style={{ textAlign: "left", paddingLeft: '0px', paddingRight: '0px' }}>
                {firstName} {lastName}
              </td>
            );
          }}
        />
        <GridColumn
          field="accountActivated"
          title="Account Activated"
          width="150px"
          cell={AtivatedStatusCell}
        />
        <GridColumn field="active" cell={StatusCell} title="Status" width="100px" />
        <GridColumn cell={ActionArea} width="305px" />
      </Grid>
    </div>
  );
};

export default ParticipantsManagementGrid;